/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Utility function to sort lifestyle categories
 */

import type { HoodLifestyleScore } from '@zcode/bizos'

// Sort the lifestyles array by score descending and then by count descending, if there are ties
export const sortLifestyles = (lifestyles: HoodLifestyleScore[]) => {
  return lifestyles
    .sort((a, b) => {
      if (a.score !== b.score) {
        return b.score - a.score
      }
      return b.count - a.count
    })
    .slice(0, 3)
}
